import React from 'react'

const MagnifyingGlassIcon = props => (
  <svg viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      opacity="0.4"
      d="M8.57327 8.36674L6.64582 6.76082L5.74874 5.76424C6.48751 4.43366 6.34128 2.66384 5.30408 1.51126C4.71696 0.859132 3.93669 0.5 3.10643 0.5C2.27618 0.5 1.4959 0.859132 0.908783 1.51126C-0.302928 2.8575 -0.302928 5.04784 0.908783 6.39408C1.4959 7.04605 2.2762 7.40534 3.10643 7.40534C3.69234 7.40534 4.25179 7.22305 4.73759 6.88858L5.6342 7.88463L7.07979 10.0261C7.28315 10.3273 7.59451 10.5 7.93364 10.5C8.2184 10.5 8.48605 10.3766 8.68755 10.1528C8.90638 9.90971 9.01928 9.57382 8.9973 9.231C8.97557 8.88789 8.82103 8.57308 8.57327 8.36674ZM4.29225 2.63521C3.63873 1.90882 2.57437 1.90858 1.9204 2.63521C1.82787 2.738 1.67797 2.738 1.58542 2.63521C1.49287 2.53242 1.49289 2.36589 1.58542 2.26308C2.42423 1.33174 3.7884 1.3315 4.62721 2.26308C4.71973 2.36587 4.71973 2.53239 4.62721 2.63521C4.58094 2.68661 4.52032 2.71232 4.45973 2.71232C4.39913 2.71232 4.33851 2.68661 4.29225 2.63521ZM5.3041 6.39408C5.36176 6.33 5.41411 6.26237 5.46627 6.19466L6.15494 6.95971L5.81326 7.33929L5.12492 6.57461C5.18592 6.51647 5.24666 6.45784 5.3041 6.39408Z"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-12.0484"
        y1="-10.7903"
        x2="11.783"
        y2="10.0822"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
)

export default MagnifyingGlassIcon
